/* Afnan Shop & Win — product page (PDP) nudge.

   Unlike the draw bar this is RENDERED by Liquid, not injected: the
   product page's markup is not replaced wholesale on cart change the way
   the drawer's is, so there is nothing to put back. What it does do is
   MOVE itself next to the add-to-cart button, because Prestige's product
   info column is built by main-product.liquid and a section can only be
   dropped above or below it, never inside it.

   It also deliberately does NOT wrap window.fetch / XHR. afnan-draw-bar.js
   already does, and a second wrapper on the same page means every cart
   request schedules two refreshes. This listens to the draw bar's
   broadcast when it's present and falls back to the theme's own cart
   events plus one /cart.js read when it isn't. */
(function () {
  'use strict';

  var ROOT = document.getElementById('asw-pdp-root');
  if (!ROOT) return;

  var CARD = document.getElementById('asw-pdp-card');
  if (!CARD) return;

  var COPY = JSON.parse(document.getElementById('asw-pdp-copy').textContent);
  var d = ROOT.dataset;
  var THRESHOLD = parseFloat(d.threshold) || 0;
  if (THRESHOLD <= 0) return;

  var currency = d.currency || 'AED';
  var endsAt = d.endsAt ? new Date(d.endsAt).getTime() : 0;

  /* Variant id -> price in MINOR units, so a variant switch re-reads the
     price without a round trip. Prices come from Liquid, which already
     has them, rather than from scraping the rendered price element -
     that element is formatted, localised, and sometimes shows a range. */
  var PRICES = {};
  try { PRICES = JSON.parse(document.getElementById('asw-pdp-prices').textContent) || {}; }
  catch (e) { PRICES = {}; }

  var cartTotal = parseInt(d.cartTotal, 10); if (isNaN(cartTotal)) cartTotal = 0;
  var price = parseInt(d.price, 10); if (isNaN(price)) price = 0;
  var qty = 1;
  var stamped = false;

  var msgEl   = CARD.querySelector('.asw-pdp-msg');
  var subEl   = CARD.querySelector('.asw-pdp-sub');
  var fillEl  = CARD.querySelector('.asw-pdp-fill');
  var ghostEl = CARD.querySelector('.asw-pdp-ghost');
  var endsEl  = CARD.querySelector('.asw-pdp-ends');

  /* ---------- money ----------
     The scale factor here is Shopify's RAW STORAGE precision, which is not
     the same thing as how many decimals a currency displays with, and
     Intl.NumberFormat's currency digit count answers the display question,
     not the storage one. Concretely: Intl says HUF and JPY have 0 fraction
     digits (that's real - it's how ICU/CLDR formats them for people), but
     Shopify's own docs are explicit that cart.total_price for a currency
     "without a subunit" still has "tenths and hundredths... appended" -
     i.e. the raw integer is still x100, exactly like USD. Trusting Intl's
     0 here would have read a HUF 43500 threshold as 435.00 and shown the
     bar qualified two orders of magnitude too early.
     The only currencies where the RAW number really is scaled differently
     are the three-decimal group (a real subunit, not a display quirk):
     BHD, JOD, KWD, OMR, TND. Every other currency - including the
     zero-decimal-DISPLAY ones - is stored x100. */
  var THREE_DECIMAL = ['BHD', 'JOD', 'KWD', 'OMR', 'TND'];
  function factor() {
    return THREE_DECIMAL.indexOf(String(currency).toUpperCase()) > -1 ? 1000 : 100;
  }
  function money(minor) {
    var v = minor / factor();
    /* Intl is the right tool for DISPLAY here - it knows HUF shows no
       decimals and BHD shows three, and gets separators/symbol placement
       right per locale. It just isn't the right tool for the scale
       conversion above, which is a storage fact, not a formatting one. */
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(v);
    } catch (e) { return currency + ' ' + v.toFixed(2); }
  }
  function fill(str, map) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  /* ---------- countdown chip ----------
     Days only, not a live ticking clock: the campaign page already owns
     the split-flap countdown, and a second second-by-second timer on the
     PDP is noise competing with the buy button. */
  function paintEnds() {
    if (!endsEl || !endsAt) return;
    var diff = endsAt - Date.now();
    if (diff <= 0) { endsEl.textContent = COPY.ended || ''; return; }
    var days = Math.floor(diff / 864e5);
    var hours = Math.floor(diff % 864e5 / 36e5);
    endsEl.textContent = days >= 1
      ? fill(COPY.ends_days, { days: days })
      : fill(COPY.ends_hours, { hours: Math.max(1, hours) });
  }

  /* ---------- paint ----------
     One qualifying ORDER earns exactly one entry - the threshold is a
     minimum, not a per-{{threshold}} multiplier. Spending further past it
     in the same cart earns nothing more; another entry only comes from a
     separate qualifying order. So there is no "entries" count and no
     "add X more for another entry" - once ok is true the fill just holds
     full and the message stops changing regardless of what's added next. */
  function paint() {
    var goal = THRESHOLD * factor();
    var adding = price * qty;
    var after = cartTotal + adding;

    var ok = cartTotal >= goal;              // already qualified, before this item
    var tips = !ok && after >= goal;         // THIS item takes them over the line

    var pct = Math.max(0, Math.min(100, (cartTotal / goal) * 100));
    /* Ghost is the slice this item would add, clipped to what's left of
       the track - overshoot has nowhere to draw and would just look wrong.
       Only meaningful pre-threshold; once ok, the track is simply full. */
    var ghostPct = Math.max(0, Math.min(100 - pct, (adding / goal) * 100));

    fillEl.style.width = pct + '%';
    if (ghostEl) ghostEl.style.width = (ok ? 0 : ghostPct) + '%';

    if (ok) {
      msgEl.textContent = COPY.qualified;
      subEl.innerHTML = COPY.qualified_sub || '';
    } else if (tips) {
      msgEl.textContent = COPY.tipping;
      subEl.innerHTML = fill(COPY.tipping_sub, { total: '<b>' + money(after) + '</b>' });
    } else {
      var short = Math.ceil(goal - cartTotal);
      msgEl.innerHTML = fill(COPY.below, { amount: '<b>' + money(short) + '</b>' });
      subEl.innerHTML = adding > 0
        ? fill(COPY.below_sub, { amount: '<b>' + money(Math.ceil(goal - after)) + '</b>' })
        : '';
    }

    CARD.classList.toggle('is-ok', ok);
    CARD.classList.toggle('is-tipping', tips);
    if (ok) {
      if (!stamped) { stamped = true; requestAnimationFrame(function () { CARD.classList.add('is-stamped'); }); }
    } else { stamped = false; CARD.classList.remove('is-stamped'); }

    paintEnds();
    CARD.hidden = false;
  }

  /* ---------- variant + quantity ----------
     Prestige fires its own variant event, but themes disagree on the name
     and some only ever update the hidden input, so the input is watched
     too and both paths land in the same place. */
  function setVariant(id) {
    if (!id) return;
    var p = PRICES[String(id)];
    if (typeof p === 'number') { price = p; paint(); }
  }

  ['variant:change', 'variant:changed', 'product:variant-change', 'theme:variant:change']
    .forEach(function (n) {
      document.addEventListener(n, function (e) {
        var v = e && e.detail && (e.detail.variant || e.detail);
        if (v && v.id) setVariant(v.id);
        else if (v && typeof v.price === 'number') { price = v.price; paint(); }
      });
    });

  var form = CARD.closest('form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'id') setVariant(t.value);
      if (t.name === 'quantity') { qty = Math.max(1, parseInt(t.value, 10) || 1); paint(); }
    });
    /* Quantity steppers in Prestige write the input programmatically, which
       fires no change event - a cheap poll on the value covers every
       stepper implementation without knowing any of them. */
    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) setInterval(function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (v !== qty) { qty = v; paint(); }
    }, 400);
  }

  /* ---------- cart total ---------- */
  function applyCart(cart) {
    if (!cart) return;
    if (typeof cart.total_price === 'number') cartTotal = cart.total_price;
    if (cart.currency) currency = cart.currency;
    paint();
  }

  /* The draw bar broadcasts every cart it applies (see the dispatch in
     afnan-draw-bar.js). When it's on the page this is the cheapest and
     most accurate source: same numbers, no second request, no race. */
  document.addEventListener('asw:draw:cart', function (e) {
    if (e && e.detail) applyCart(e.detail);
  });

  var busy = false, again = false;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(applyCart)
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  ['cart:change', 'cart:updated', 'cart:refresh', 'cart:item-added',
   'theme:cart:updated', 'CartUpdated', 'variant:add'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      var c = e && e.detail && (e.detail.cart || e.detail);
      if (c && typeof c.total_price === 'number') applyCart(c);
      else setTimeout(refresh, 150);
    });
  });

  /* ---------- init ----------
     No relocation logic: this is a product-info BLOCK now (see
     afnan-pdp-nudge.liquid), so its position in the page is whatever the
     merchant dragged it to in the theme editor's block list, exactly like
     Tier offer or Estimated Delivery. Nothing here needs to move it.
     Painted immediately from Liquid's server-rendered cart total, then
     corrected by a /cart.js read - the page may have been served from
     Shopify's full-page cache with someone else's (or an older) total. */
  paint();
  refresh();
  setInterval(paintEnds, 60000);
})();
